import { FC } from "react";
import styles from './index.module.less';
import right from '../../assets/right.svg';
import { useNavigate } from "react-router-dom";

const Index: FC = (props) => {
    const navigate = useNavigate();
    return (
        <div className={styles['header-row']}>
            <div className={styles.header}>{props.title}</div>
            {
                props.hasMore &&
                <div className={styles.more} onClick={() => navigate(props.path)}>
                    更多
                    <img className={styles.arrow} src={right} alt="" />
                </div>
            }
        </div>
    );
}

export default Index;